import { render, staticRenderFns } from "./custom-select.vue?vue&type=template&id=687947b6&scoped=true&"
import script from "./custom-select.vue?vue&type=script&lang=js&"
export * from "./custom-select.vue?vue&type=script&lang=js&"
import style0 from "./custom-select.vue?vue&type=style&index=0&id=687947b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687947b6",
  null
  
)

component.options.__file = "custom-select.vue"
export default component.exports